<section
  class="network-preview"
  [class.network-preview--fill-height]="fillHeight()"
  aria-label="Exception network preview">
  <header class="network-preview__head">
    <span class="network-preview__title">Network · <span>OKAN</span></span>
    @if (getTimestampLabel(); as timestamp) {
      <span class="network-preview__timestamp">{{ timestamp }}</span>
    }
  </header>
  <div class="network-preview__frame-container">
    <iframe
      #networkPreviewFrame
      (load)="onInlineFrameLoad()"
      class="network-preview__frame"
      src="/ontology-dynamic.html"
      title="Exception Network Preview"
      loading="lazy"></iframe>

    @if (expandable()) {
      <button
        type="button"
        class="network-preview__expand"
        aria-label="Expand network preview"
        title="Expand"
        (click)="openOverlay()">
        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="15 3 21 3 21 9" /><polyline points="9 21 3 21 3 15" /><line x1="21" y1="3" x2="14" y2="10" /><line x1="3" y1="21" x2="10" y2="14" />
        </svg>
      </button>
    }

    @if (inlineUiMode() === 'compact') {
      <div class="network-preview__legend" aria-hidden="true">
        <span class="np-lg"><svg width="12" height="12" viewBox="0 0 12 12"><polygon points="3,1 9,1 12,6 9,11 3,11 0,6" fill="#2dd4bf" /></svg>Facility</span>
        <span class="np-lg"><svg width="12" height="12" viewBox="0 0 12 12"><polygon points="6,1.5 11,11 1,11" fill="#f59e0b" /></svg>Jacket</span>
        <span class="np-lg"><svg width="12" height="12" viewBox="0 0 12 12"><circle cx="6" cy="6" r="5" fill="#60a5fa" /></svg>Well</span>
        <span class="np-lg"><svg width="12" height="12" viewBox="0 0 12 12"><rect x="1" y="1" width="10" height="10" rx="1" fill="#f472b6" /></svg>Equip</span>
      </div>
    }
  </div>
</section>

@if (isExpanded()) {
  <div class="network-preview-overlay" role="dialog" aria-modal="true" aria-label="Expanded network preview">
    <button
      type="button"
      class="network-preview-overlay__backdrop"
      aria-label="Close expanded network preview"
      (click)="closeOverlay()"></button>

    <section class="network-preview-overlay__panel">
      <div class="network-preview-overlay__frame-container">
        <iframe
          #networkPreviewOverlayFrame
          (load)="onOverlayFrameLoad()"
          class="network-preview-overlay__frame"
          src="/ontology-dynamic.html"
          title="Expanded Exception Network Preview"
          loading="lazy"></iframe>
      </div>
    </section>
  </div>
}
